// extracted by mini-css-extract-plugin
module.exports = {"avatar":"style_avatar__10vs4","borderMost":"style_borderMost__2yXGX","animaBorder":"style_animaBorder__3Pao6","borderLess":"style_borderLess__2_LK8"};